
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts",
      function () {
        return require("private-next-pages/posts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts"])
      });
    }
  